import { StyleSheet } from "aphrodite";

const Style = StyleSheet.create({
  outletContainer: {
    backgroundColor: "#fff",
    margin: "5px",
    boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    padding: "10px",
    "@media (max-width: 768px)": {
      margin: "5px 10px 15px 15px",
      padding: "13px 10px 15px 20px",
    },
  },
  outletContainertable: {
    backgroundColor: "#fff",
    margin: "1rem",
    padding: "10px 15px",
  },
  main: {
    flexGrow: 1,
    background: "#f7f7f9",
    width: "81%",
    position: "relative",
    zIndex: 1200,
    height: "100vh",
  },
  mainMobile: {
    flexGrow: 1,
    background: "#f7f7f9",
    width: "100%",
    position: "fixed",
    height: "100vh",
  },
});

export default Style;
